import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/LanguageContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const { t } = useI18n();
  const a = t.admin;
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || a.loginError);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full border-b border-dark-border bg-transparent py-3 px-0 rounded-none focus:outline-none focus:border-brass transition-colors font-mono text-sm text-ivory placeholder:text-ivory/30";

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center px-6">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm border border-dark-border p-10">
        <div className="font-mono text-sm tracking-[0.35em] uppercase text-ivory mb-2">HABITUS</div>
        <h1 className="font-headings text-3xl text-ivory mb-1">{a.loginTitle}</h1>
        <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ivory/40 mb-10">{a.loginSubtitle}</p>

        <label className="text-[0.7rem] font-mono uppercase tracking-widest text-ivory/50 mb-2 block">{a.email}</label>
        <input data-testid="admin-email" type="email" className={inputCls + " mb-8"} value={email} onChange={(e) => setEmail(e.target.value)} />

        <label className="text-[0.7rem] font-mono uppercase tracking-widest text-ivory/50 mb-2 block">{a.password}</label>
        <input data-testid="admin-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />

        {error && <p data-testid="admin-login-error" className="mt-6 font-mono text-xs text-red-400">{error}</p>}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-10 w-full bg-brass text-dark-bg hover:bg-brass-muted transition-colors duration-300 py-4 font-mono uppercase tracking-widest text-xs disabled:opacity-50"
        >
          {loading ? a.signingIn : a.signIn}
        </button>
      </form>
    </div>
  );
}
